import { useMemo, useState } from 'react';
import { t } from 'utilities/TranslationUtils';

// components
import { TextFieldsFilter, SelectFilter, RadioFilter } from './components';
import { AppUseIcon } from 'components/ui';
import { Popper } from '@mui/material';
import DateRangeSeparatePickersFilter from './components/DateRangeSeparatePickersFilter';

// types
import { IAppTableFilters } from 'services/AppTableFilters';
import {Chip} from "@trackman/web-shared-components";

export const GetColumnFilterComponent = (filter: any, CallBackFn = (value: any) => {}) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const applyFilter = (value?: any) => {
    setAnchorElement(null);
    filter.onApply(value);
    CallBackFn(value);
  };

  return (
    <div className='filter-button-and-popup' onClick={(e) => e.stopPropagation()}>
      <button
        type='button'
        className='popup-activate-button mx-1 btn btn-transparent p-0'
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          setAnchorElement(anchorElement ? null : event.currentTarget);
        }}
      >
        <AppUseIcon name='FilterIcon' height='17' width='16' />
      </button>
      {!!anchorElement && (
        <>
          <div className='backdrop' onClick={() => setAnchorElement(null)} />

          <Popper
            data-test={'filter-popper'}
            className={`${filter.className || ''}`}
            open={!!anchorElement}
            anchorEl={anchorElement}
            placement='bottom'
          >
            <div>
              { filter.type === 'textfields' && (<TextFieldsFilter filter={filter} onApply={applyFilter} />) }
              { filter.type === 'select' && (<SelectFilter filter={filter} onApply={applyFilter} />) }
              { filter.type === 'date-range-separate-pickers' && (<DateRangeSeparatePickersFilter filter={filter} onApply={applyFilter} />) }
              { filter.type === 'radio' && (<RadioFilter filter={filter} onApply={applyFilter} />) }
            </div>
          </Popper>
        </>
      )}
    </div>
  );
};

export const getFilterChips = (appTableFiltersInstance: IAppTableFilters) => {
  return FilterChips(appTableFiltersInstance.filters.map((f) => ({ ...f, onRemove: appTableFiltersInstance.removeFilter })));
};

export const FilterChips = (filters: any[]) => {
  return (
    <div data-test='current-filters' className='current-filters'>
      {filters.length === 0 && (
        <span className='font-400 font-15 font-lato px-2'>{t('table.added_filters_will_appear_here')}</span>
      )}
      {filters?.map((f, index) => FChip(f, index))}
    </div>
  );
};

const FChip = (filter: any, index: number) => {
  return (
    <div key={index} className='current-filter' title={filter.label}>
      <Chip
        id={`filter-chip-${filter?.id}-${index}`}
        key={index}
        label={filter.label}
        color='#414141'
        onDelete={() => filter.onRemove(filter)}
      />
    </div>
  );
};
